module.exports = __webpack_public_path__ + "img/laurent.c90ffa48.png";